import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import BasicLeafNodeRenderer from './BasicLeafNodeRenderer'
import BasicFolderNodeRenderer from './BasicFolderNodeRenderer'
import BasicEmptyNodeRenderer from './BasicEmptyNodeRenderer'
import styles from './Tree.css'

export default class TreeViewItem extends React.Component {
  static propTypes = {
    node: PropTypes.object,
    leafComponent: PropTypes.any,
    folderComponent: PropTypes.any,
    emptyComponent: PropTypes.any,
    maxDepth: PropTypes.number,
    onClick: PropTypes.func,
    getExpanded: PropTypes.func,
    getName: PropTypes.func,
    getChildren: PropTypes.func,
    className: PropTypes.string,
  }
  constructor(props, context) {
    super(props, context)
    this.state = {
      // expanded: this.props.getExpanded(this.props.node),
      children: this.props.getChildren(this.props.node),
    }
  }
  handleClick = node => {
    const nodes = this.state.children.slice()

    // if node has `collapsable` false. It will not be closable
    if (node && node.collapsable === false) {
      this.props.onClick(node)
      return false
    }

    if (nodes.indexOf(node) > -1 && node.hasOwnProperty('children')) {
      nodes[nodes.indexOf(node)].expanded = !nodes[nodes.indexOf(node)].expanded
      this.setState({children: nodes})
    }
    this.props.onClick(node)
  }
  render() {
    let {
      node,
      leafComponent,
      folderComponent,
      emptyComponent,
      maxDepth,
      onClick,
      getExpanded,
      getName,
      getChildren,
      className,
    } = this.props
    let component = null

    leafComponent = node && node.leafComponent || leafComponent || BasicLeafNodeRenderer
    folderComponent = node && node.folderComponent || folderComponent || BasicFolderNodeRenderer
    emptyComponent = node && node.emptyComponent || emptyComponent || BasicEmptyNodeRenderer
    getChildren = node && node.getChildren || getChildren
    getExpanded = node && node.getExpanded || getExpanded

    const expanded = node && getExpanded(node)
    const childrenNodes = expanded && this.state.children
    const haveChildren = childrenNodes && childrenNodes.length > 0 || false
    const isFolder = haveChildren || typeof expanded === 'boolean'

    // select the renderer component
    if (!node) {
      component = emptyComponent
    } else {
      if (node.component) {
        component = node.component
      } else {
        if (isFolder) {
          component = folderComponent
        } else {
          component = leafComponent
        }
      }
    }

    return (
      <div className={classnames(styles.treeViewItem, className, (expanded ? styles.treeViewItemExpanded : null))}>
        {component({ node, onClick, expanded, getName })}
        {isFolder && maxDepth > 0 && expanded &&
        <div className={styles.children}>
          {haveChildren === false
            ? emptyComponent({})
            : childrenNodes.map((child, index) =>
              <TreeViewItem
                node={child}
                leafComponent={leafComponent}
                folderComponent={folderComponent}
                emptyComponent={emptyComponent}
                maxDepth={maxDepth - 1}
                onClick={this.handleClick}
                key={index}
                getExpanded={getExpanded}
                getName={getName}
                getChildren={getChildren} />
            )}
        </div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/Tree/TreeViewItem.js